export default __webpack_public_path__ + "static/media/Bloco_de_carnaval_Carmelitas.d6cba817.jpg";